import type { DrawLevel } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Prize from '../../Prize/Prize';

import { TXTCLI_Probability_1M } from './ProbabilityRow.messages.json';

interface ProbabilityRowProps {
  transposedData: DrawLevel[];
  currency: number;
}

const ProbabilityRow: React.FC<ProbabilityRowProps> = ({ transposedData, currency }) => (
  <tr>
    <th>
      <Translation {...TXTCLI_Probability_1M} />
    </th>
    {transposedData.map(
      (level: DrawLevel, drawIndex) =>
        level.odds && <Prize key={drawIndex} value={level.odds} currency={currency} />
    )}
  </tr>
);

export default ProbabilityRow;
